import { useTranslate, useRecordContext } from 'react-admin';
import MailIcon from '@mui/icons-material/Mail';

const ConditionalRegisteredField = ({
    sortable,
    sortByOrder,
    showInvitation,
    ...rest
}) => {
    const translate = useTranslate();
    const record = useRecordContext();

    if (!record) return null;

    // Check if there are any pending invitations
    const hasPendingInvitations = () => {
        if (!record.schools || record.schools.length === 0) return false;

        return record.schools.some(school =>
            school.public?.invitations?.some(
                invitation => invitation.status === 0
            )
        );
    };

    if (record.status === 3) {
        // Status is 3, check for pending invitations
        const isPending = hasPendingInvitations();

        return (
            <span style={{ display: 'flex', alignItems: 'center' }}>
                <span
                    title={`${new Date(record.registered).toLocaleDateString(
                        'fi-FI'
                    )}`}
                >
                    {translate(`resources.user.status.${record.status}`)}
                </span>
                {showInvitation && (
                    <MailIcon
                        style={{
                            color: isPending ? '#4caf50' : '#aaaaaa', // Green if pending, grey otherwise
                            fontSize: '1rem',
                            marginLeft: '8px',
                        }}
                        titleAccess={
                            isPending
                                ? translate('resources.user.invitation.pending')
                                : translate('resources.user.invitation.none')
                        }
                    />
                )}
            </span>
        );
    } else if (record.status === 0) {
        // If status is 0, display the registration date
        return (
            <span>
                {new Date(record.registered).toLocaleDateString('fi-FI')}
            </span>
        );
    } else {
        // Otherwise, display the status translation with the date as a title
        return (
            <span
                title={`${new Date(record.registered).toLocaleDateString(
                    'fi-FI'
                )}`}
            >
                {translate(`resources.user.status.${record.status}`)}
            </span>
        );
    }
};

export default ConditionalRegisteredField;
